import { useState } from 'react';
import { WEB_ICO } from '../../shell/icons';
import { WebModal } from '../../shell/WebModal';

const VOCAB_OPTIONS = [5, 10, 20, 50];
const GRAMMAR_OPTIONS = [1, 2, 3, 5];

interface Goals {
  vocab: number;
  grammar: number;
}

function ChipRow({ options, value, onChange }: { options: number[]; value: number; onChange: (v: number) => void }) {
  return (
    <div style={{ display: 'flex', gap: 8 }}>
      {options.map((o) => {
        const active = o === value;
        return (
          <button
            key={o}
            onClick={() => onChange(o)}
            style={{
              flex: 1,
              height: 44,
              borderRadius: 999,
              cursor: 'pointer',
              fontFamily: 'var(--font-vi)',
              fontWeight: 700,
              fontSize: 15,
              background: active ? 'var(--cta-default)' : 'var(--surface-page)',
              color: active ? '#fff' : 'var(--ink)',
              border: active ? 'none' : '1px solid var(--border-default)',
            }}
          >
            {o}
          </button>
        );
      })}
    </div>
  );
}

export function DailyGoalModal({ goals, onClose, onSave }: { goals: Goals; onClose: () => void; onSave: (g: Goals) => void }) {
  const [vocab, setVocab] = useState(goals.vocab);
  const [grammar, setGrammar] = useState(goals.grammar);

  const vocabMinutes = Math.round(vocab * 0.6 + 3);
  const vocabLessons = Math.max(1, Math.round(vocab / 8));
  const grammarMinutes = grammar * 4 + 3;
  const grammarLessons = Math.max(1, Math.round(grammar / 2));

  return (
    <WebModal onClose={onClose} width={380}>
      <div style={{ padding: 24, display: 'flex', flexDirection: 'column', gap: 18, fontFamily: 'var(--font-vi)' }}>
        <div>
          <h2 style={{ fontSize: 19, fontWeight: 700, color: 'var(--ink)', margin: 0 }}>Mục tiêu mỗi ngày</h2>
          <p style={{ fontSize: 12.5, color: 'var(--text-secondary)', margin: '4px 0 0', lineHeight: 1.45 }}>
            Đặt riêng cho hai nhánh. Học vượt mục tiêu vẫn được, không bị chặn.
          </p>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <span style={{ fontSize: 13.5, fontWeight: 700, color: 'var(--ink)' }}>Từ vựng</span>
            <span style={{ fontSize: 12, color: 'var(--text-secondary)' }}>từ mới / ngày</span>
          </div>
          <ChipRow options={VOCAB_OPTIONS} value={vocab} onChange={setVocab} />
          <div style={{ fontSize: 12, color: 'var(--text-secondary)' }}>{`≈ ${vocabLessons} bài · khoảng ${vocabMinutes} phút/ngày`}</div>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <span style={{ fontSize: 13.5, fontWeight: 700, color: 'var(--ink)' }}>Ngữ pháp</span>
            <span style={{ fontSize: 12, color: 'var(--text-secondary)' }}>mẫu mới / ngày</span>
          </div>
          <ChipRow options={GRAMMAR_OPTIONS} value={grammar} onChange={setGrammar} />
          <div style={{ fontSize: 12, color: 'var(--text-secondary)' }}>{`≈ ${grammarLessons} bài · khoảng ${grammarMinutes} phút/ngày`}</div>
        </div>

        {vocab >= 20 && (
          <div style={{ display: 'flex', gap: 8, background: 'var(--warning-bg)', borderRadius: 'var(--radius-control)', padding: '10px 12px' }}>
            <span style={{ flexShrink: 0, marginTop: 1 }}>{WEB_ICO.warn()}</span>
            <span style={{ fontSize: 12.5, color: 'var(--warning-text)', lineHeight: 1.45, fontWeight: 600 }}>
              {`Với ${vocab} từ/ngày, sau 2 tuần bạn sẽ ôn khoảng ${vocab * 4} thẻ mỗi ngày (~${Math.round(vocab * 0.6)} phút). Chắc chưa?`}
            </span>
          </div>
        )}

        <div style={{ display: 'flex', gap: 12 }}>
          <button
            onClick={onClose}
            style={{
              height: 48,
              padding: '0 18px',
              borderRadius: 'var(--radius-control)',
              background: 'transparent',
              border: '1px solid var(--border-default)',
              color: 'var(--text-secondary)',
              cursor: 'pointer',
              fontFamily: 'var(--font-vi)',
              fontWeight: 600,
              fontSize: 15,
            }}
          >
            Huỷ
          </button>
          <button
            onClick={() => onSave({ vocab, grammar })}
            style={{
              flex: 1,
              height: 48,
              borderRadius: 'var(--radius-control)',
              background: 'var(--cta-default)',
              color: '#fff',
              border: 'none',
              cursor: 'pointer',
              fontFamily: 'var(--font-vi)',
              fontWeight: 600,
              fontSize: 16,
            }}
          >
            Lưu
          </button>
        </div>
      </div>
    </WebModal>
  );
}
